function addHover() {
  const hoverMenu = document.querySelector(".hover-menu");
  if (!hoverMenu) {
    return;
  }

  document
    .querySelectorAll(".hover-menu .mega-menu__content")
    .forEach((item) => {
      item.style.display = "block";
    });

  const menuItems = document.querySelectorAll(
    "ul.list-menu > li > header-menu > .mega-menu"
  );
  const inlineMenu = document.querySelector(".list-menu--inline"); // Select the element that controls the link colors

  menuItems.forEach((item) => {
    const span = item.querySelector("span");

    span.addEventListener("mouseenter", () => {
      menuItems.forEach((i) => {
        if (i === item) {
          i.classList.add("active");
          if (inlineMenu) {
            inlineMenu.classList.add("menu-active"); // Add class when active
          }
        } else {
          i.classList.remove("active");
        }
      });
      hoverMenu.classList.add("open");
    });
  });

  document.querySelector("sticky-header").addEventListener("mouseleave", () => {
    hoverMenu.classList.remove("open");
    if (inlineMenu) {
      inlineMenu.classList.remove("menu-active"); // Remove class when not active
    }
  });
}

document.addEventListener("DOMContentLoaded", addHover);

document.addEventListener("DOMContentLoaded", () => {
  const banners = document.querySelectorAll(
    ".banner[data-header-text-color], .video-section[data-header-text-color]"
  );

  if (banners.length === 0) return;

  const stickyHeader = document.querySelector("sticky-header");
  const headerEl = document.querySelector("header");
  if (!stickyHeader || !headerEl) return;

  // Logo is an image, so light colours make it white and dark colours make it black
  const logoFilterFor = (color) => {
    const probe = document.createElement("span");
    probe.style.color = color;
    document.body.appendChild(probe);
    const [r, g, b] = getComputedStyle(probe).color.match(/[\d.]+/g).map(Number);
    probe.remove();
    return (r * 299 + g * 587 + b * 114) / 1000 > 128 ? "brightness(0) invert(1)" : "brightness(0)";
  };

  let currentBanner;
  let ticking = false;

  // Use the banner that is actually behind the header, not just any banner in the viewport
  const update = () => {
    ticking = false;
    const headerRect = headerEl.getBoundingClientRect();
    const probeY = Math.max(0, headerRect.top + headerRect.height / 2);

    let activeBanner = null;
    banners.forEach((banner) => {
      const rect = banner.getBoundingClientRect();
      if (rect.top <= probeY && rect.bottom >= probeY) activeBanner = banner;
    });

    if (activeBanner === currentBanner) return;
    currentBanner = activeBanner;

    if (activeBanner) {
      headerEl.classList.add("has-intersection");
      const color = activeBanner.getAttribute("data-header-text-color");
      stickyHeader.style.setProperty("--header-fg", color);
      stickyHeader.style.setProperty("--header-logo-filter", logoFilterFor(color));
    } else {
      headerEl.classList.remove("has-intersection");
      stickyHeader.style.removeProperty("--header-fg");
      stickyHeader.style.removeProperty("--header-logo-filter");
    }
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  update();
});

document.addEventListener("DOMContentLoaded", () => {
  const hideLogoBanners = document.querySelectorAll(".banner[data-hide-logo]");
  if (hideLogoBanners.length === 0) return;

  const logoLinks = document.querySelectorAll(".header__heading-link");
  let intersectingCount = 0;

  const logoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        intersectingCount++;
        logoLinks.forEach((el) => el.style.removeProperty("opacity"));
      } else {
        intersectingCount = Math.max(0, intersectingCount - 1);
        if (intersectingCount === 0) {
          logoLinks.forEach((el) => (el.style.opacity = "1"));
        }
      }
    });
  });

  hideLogoBanners.forEach((banner) => logoObserver.observe(banner));
});

// Predictive search - clear search button
const predictiveSearch = document.querySelector("predictive-search");
if (predictiveSearch) {
  const searchInput = predictiveSearch.querySelector(".search__input");
  const clearButton = predictiveSearch.querySelector(".search__reset");
  if (searchInput && clearButton) {
    searchInput.addEventListener("input", () => {
      if (searchInput.value.length > 0) {
        clearButton.style.display = "flex";
      } else {
        clearButton.style.display = "none";
      }
    });

    clearButton.addEventListener("click", (e) => {
      searchInput.value = "";
      clearButton.style.display = "none";
      predictiveSearch.removeAttribute("open");
      searchInput.focus();
    });
  }
}
// Test for Bundle disrupter drawer
(function () {
  if (window.__biBundleDrawerInit) return;
  window.__biBundleDrawerInit = true;

  const SELECTORS = {
    trigger: "[data-drawer-target]",
    drawer: ".bi-drawer",
    overlay: ".bi-drawer-overlay",
    close: "[data-close-drawer]",
  };

  document.querySelectorAll(SELECTORS.drawer).forEach(function (el) {
    if (el.parentElement !== document.body) document.body.appendChild(el);
  });
  document.querySelectorAll(SELECTORS.overlay).forEach(function (el) {
    if (el.parentElement !== document.body) document.body.appendChild(el);
  });

  const focusableSel = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(",");

  let active = null;
  let lastFocus = null;
  let untrap = null;

  function getOverlayFor(drawer) {
    return document.querySelector(
      SELECTORS.overlay + '[data-for="' + drawer.id + '"]'
    );
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? "hidden" : "";
    document.body.style.overflow = lock ? "hidden" : "";
    document.body.style.touchAction = lock ? "none" : "";
  }

  function trapFocus(container) {
    const nodes = Array.from(container.querySelectorAll(focusableSel));
    if (!nodes.length) return () => {};
    const first = nodes[0];
    const last = nodes[nodes.length - 1];

    function onKey(e) {
      if (e.key === "Tab") {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      } else if (e.key === "Escape") {
        closeDrawer();
      }
    }
    container.addEventListener("keydown", onKey);
    return () => container.removeEventListener("keydown", onKey);
  }

  function openDrawer(drawer, triggerEl) {
    const overlay = getOverlayFor(drawer);
    if (!overlay) return;

    lastFocus = triggerEl || document.activeElement;

    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    overlay.hidden = false;
    // Force reflow so transition plays when adding class
    overlay.getBoundingClientRect();
    overlay.classList.add("is-active");

    triggerEl?.setAttribute("aria-expanded", "true");
    lockScroll(true);

    active = { drawer, overlay, trigger: triggerEl };
    untrap = trapFocus(drawer);

    // Focus first focusable, else the drawer itself
    const first = drawer.querySelector(focusableSel) || drawer;
    first.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!active) return;
    const { drawer, overlay, trigger } = active;

    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    overlay.classList.remove("is-active");
    trigger?.setAttribute("aria-expanded", "false");

    // After transition, hide overlay to restore clicks
    const tidy = () => {
      overlay.hidden = true;
      overlay.removeEventListener("transitionend", tidy);
    };
    overlay.addEventListener("transitionend", tidy);

    untrap && untrap();
    lockScroll(false);

    // Restore focus
    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus({ preventScroll: true });
    }

    active = null;
    lastFocus = null;
    untrap = null;
  }

  // Open on trigger click
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(SELECTORS.trigger);
    if (trigger) {
      const targetSel = trigger.getAttribute("data-drawer-target");
      const drawer = document.querySelector(targetSel);
      if (drawer) {
        e.preventDefault(); // prevent navigating the href
        openDrawer(drawer, trigger);
      }
    }

    // Close button or overlay click
    if (
      e.target.closest(SELECTORS.close) ||
      (active && e.target === active.overlay)
    ) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // Close on Escape (in case the drawer doesn't have focus)
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && active) {
      e.preventDefault();
      closeDrawer();
    }
  });
})();
